import React from "react";
import { ThemeProvider as MUIThemeProvider } from "@mui/material/styles";
import { useTheme } from "./useTheme";


export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    const { theme } = useTheme();

    return (
        <MUIThemeProvider theme={theme}>
            {children}
        </MUIThemeProvider>
    );
};
